import React, { useEffect } from 'react';
import { SalesPage } from './components/SalesPage';
import { initPixel, trackPageView } from './lib/pixel';
export function App() {
  useEffect(() => {
    initPixel();
    trackPageView();
  }, []);
  return <SalesPage data-id="element-0" />;
}